export const FRAME_LOCAL_STORAGE_KEY = 'frame';
